import { render } from "./ko.vue?vue&type=template&id=7bd5b7d8&ts=true"
import script from "./ko.vue?vue&type=script&lang=ts"
export * from "./ko.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__